import * as React from 'react'
import { Typography, Button, Table, TableContainer, Paper, TableCell, TableRow, TableHead, makeStyles, TableBody, IconButton, withStyles, Theme, createStyles, Dialog, DialogContent, TextField, MenuItem, DialogActions, Box, DialogTitle } from '@material-ui/core'
import AutoCheckInput from '../../components/AutoCheckInput';
import axios from 'axios'
import CancelIcon from '@material-ui/icons/Cancel';
import { useFeedback } from '../../components/Feedback';
import useRefresh from '../../hooks/useRefresh';
import { MembershipLevelName, MembershipLevel } from '../../constants';
import { setUserMembership, importUserByExcel } from '../../utils/api';
import moment from 'moment'
import UploadDialog from '../../components/UploadDialog';
import { createFalse } from 'typescript';
import NationalCodeSelect from '../../components/NationalCodeSelect';
const useStyles = makeStyles({
    table: {
        minWidth: 650,
        backgroundColor: '#fff'
    },
    addBox: {
        display: 'flex',
        alignItems: 'center'
    }
});
type Customer = {
    id: number
    mobile: number
    name: number,
    create_time: number,
    membership: { [key: string]: string },
    agreement?: boolean,
    national_code: number,
}

const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: theme.palette.secondary.light,
            color: theme.palette.common.white,
        },
        body: {
            fontSize: 14,
        },
    }),
)(TableCell);

const defaultCustomers: Customer[] = []
const User = () => {
    const { showToast, showDialog, showLoading, hideLoading } = useFeedback()
    const classes = useStyles()
    const [openImportUser, setOpenImportUser] = React.useState(false)
    const [openAddUser, setOpenAddUser] = React.useState(false)
    const [customers, setCustomers] = React.useState(defaultCustomers)
    const [mobile, setMobile] = React.useState('')
    const [user, setUser] = React.useState({ mobile: '', nationalCode: '86' })
    const [openMembershipDialog, setOpenMembershipDialog] = React.useState(false)
    const [membership, setMembership] = React.useState({
        level: MembershipLevel.Normal,
        time: '12',
        userId: ''
    })
    const [stateNav, setStateNav] = React.useState([{
        id: 0,
        navName: '今日',
        type: 0,
        activeColor: true,
    }, {
        id: 1,
        navName: '最近7日',
        type: 7,
        activeColor: false,
    }, {
        id: 2,
        navName: '所有',
        type: 99,
        activeColor: false,
    }])


    React.useEffect(() => {
        loadClientUer(0)
    }, [])
    useRefresh(() => {
        loadClientUer(0)
    })
    const loadCustomers = () => {
        axios.get('/api/admin/client/list').then(res => {
            setCustomers(res.data)
        }).catch(res => {

        })
    }
    const addButtonDisable = () => {
        return /^1[3456789]\d{9}$/.test(mobile)
    }
    const handleMobileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setMobile(event.target.value)
    }

    const handleAddCustom = () => {

        if (!(user.nationalCode=='86'?/^1[3456789]\d{9}$/.test(user.mobile):/^\d{6,}$/.test(user.mobile))) {
            showToast('手机号格式不正确')
            return;
        }

        axios.post('/api/admin/client/add', { mobile: user.mobile, nationalCode: user.nationalCode }).then(res => {
            setOpenAddUser(false)
            setUser({ mobile: '', nationalCode: '86' })
            loadClientUer(0);
        }).catch(error => {
            if (error.response && error.response.status === 403) {
                showToast('添加失败，用户已存在')
            }
        })
    }
    const handleSearchCustom = () => {
        axios.post('/api/admin/client/search', { mobile }).then(res => {
            if (res.data.length == 0) {
                showToast('用户不存在')
            } else {
                setCustomers(res.data)
            }

        })
        let navList = stateNav
        navList.map((item, idx) => {
            navList[idx].activeColor = false
        })
        handleStateNavChange(navList)

    }
    const loadClientUer = (type: number) => {
        axios.post('/api/admin/client/load', { type }).then(res => {
            if (res.data.length == 0) {
                showToast('无用户')
            } else {
                setCustomers(res.data)
            }

        })
    }

    const handleDelUser = (id: number) => () => {
        showDialog('是否确定删除该用户?', '删除提示', '取消', '确定')
    }

    const parseMembership = (membership: { [key: string]: string }) => {
        if (membership) {
            return MembershipLevelName[membership.level]
        }
        return '注册会员'
    }

    const parseMembershipExpired = (membership: { [key: string]: string }) => {
        if (membership && membership.expired_time) {
            return moment(+membership.expired_time).format('YYYY-MM-DD HH:mm')
        }
        return '-'
    }

    const handleSetMembership = (client: Customer) => () => {
        setMembership({
            userId: `${client.id}`,
            level: client.membership ? client.membership.level : MembershipLevel.Normal,
            time: '12'
        })
        setOpenMembershipDialog(true)
    }

    const onMembershipChange = (key: 'level' | 'time') => (event: React.ChangeEvent<HTMLInputElement>) => {
        setMembership({ ...membership, [key]: event.target.value })
    }

    const handleSaveMembership = () => {
        setUserMembership(membership.level, membership.time, membership.userId).then(res => {
            if (res.data.type === 'success') {
                showToast('设置成功')
                setOpenMembershipDialog(false)
                loadCustomers()
            } else {
                showToast('设置失败')
            }
        }).catch(e => {
            showToast('设置失败')
        })
    }


    const handleImport = (path: string) => {
        showLoading('')
        importUserByExcel(path).then(res => {
            hideLoading()
            if (res.data.type === 'success') {
                showToast('导入成功')
                loadCustomers()
                setOpenImportUser(false)
            } else {
                showToast(`导入失败,${res.data.msg}`)
            }
        }).catch(e => {
            hideLoading()
            showToast('导入失败，请检查数据格式是否正确')
        })
    }

    const handleStateNavChange = (list: any) => {
        setMembership(list)
    }

    return <React.Fragment>
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box display="flex" alignItems="center">
                <Typography variant="inherit">搜索用户</Typography>
                <AutoCheckInput notNull onChange={handleMobileChange} style={{ marginLeft: '10px' }} value={mobile} label="输入手机号" placeholder="输入手机号" />
                <Button onClick={handleSearchCustom}  style={{ marginLeft: '10px' }} variant="contained" color="secondary">搜索</Button>
                <Button onClick={e => setOpenAddUser(true)} style={{ marginLeft: '20px' }} variant="contained" color="secondary">添加用户</Button>
            </Box>
            <Box>
                {stateNav.map((item, index) => {
                    return (
                        <Button
                            style={{
                                marginRight: '10px',
                                backgroundColor: item.activeColor ? '#69a9c7' : '',
                            }}
                            onClick={(e) => {
                                let navList = [...stateNav]
                                navList.map((item, idx) => {
                                    if (idx === index) {
                                        navList[idx].activeColor = true
                                    } else {
                                        navList[idx].activeColor = false
                                    }
                                })
                                handleStateNavChange(navList)
                                loadClientUer(item.type)
                            }}
                        >{item.navName}</Button>
                    )
                })}

            </Box>
        </Box>
        <TableContainer component={Paper} style={{ backgroundColor: '#fff', marginTop: '20px' }}>
            <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                        <StyledTableCell align="center">姓名</StyledTableCell>
                        <StyledTableCell align="center">手机号</StyledTableCell>
                        <StyledTableCell align="center">会员级别</StyledTableCell>
                        <StyledTableCell align="center">注册时间</StyledTableCell>
                        <StyledTableCell align="center">到期时间</StyledTableCell>
                        <StyledTableCell align="center">操作</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {customers.map(customer => <TableRow key={customer.id}>
                        <TableCell align="center">{customer.name}</TableCell>
                        <TableCell align="center">+{customer.national_code + ' ' + customer.mobile}</TableCell>
                        <TableCell align="center">{parseMembership(customer.membership)}</TableCell>
                        <TableCell align="center">{customer.create_time ? moment(customer.create_time).format('YYYY-MM-DD HH:mm') : ''}</TableCell>
                        <TableCell align="center">{parseMembershipExpired(customer.membership)}</TableCell>
                        <TableCell align="center">
                            <Button onClick={handleSetMembership(customer)}>设置会员</Button>
                        </TableCell>
                    </TableRow>)}
                </TableBody>
            </Table>
        </TableContainer>

        <Dialog open={openMembershipDialog} onClose={() => setOpenMembershipDialog(false)}>
            <DialogContent>
                <Box width="140px">
                    <TextField fullWidth label="会员级别" onChange={onMembershipChange('level')} select size="small" value={membership.level}>
                        {Object.keys(MembershipLevel).map(key => <MenuItem key={key} value={MembershipLevel[key]}>
                            {MembershipLevelName[MembershipLevel[key]]}
                        </MenuItem>)}
                    </TextField>
                </Box>
                <Box width="140px" mt={2}>
                    <TextField fullWidth onChange={onMembershipChange('time')} label="设置时长(月)" value={membership.time} />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpenMembershipDialog(false)}>取消</Button>
                <Button onClick={handleSaveMembership}>确定</Button>
            </DialogActions>
        </Dialog>

        <Dialog open={openAddUser} onClose={() => setOpenAddUser(false)}>
            <DialogTitle>添加用户</DialogTitle>
            <DialogContent>
                <AutoCheckInput
                    InputProps={{
                        startAdornment: <NationalCodeSelect value={user.nationalCode} onChange={e => setUser({ ...user, nationalCode: e.target.value })} />
                    }}
                    type="tel" nationalCode={user.mobile} label="手机号" notNull mobile value={user.mobile} onChange={e => setUser({ ...user, mobile: e.target.value })} />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpenAddUser(false)}>取消</Button>
                <Button onClick={handleAddCustom}>确定</Button>
            </DialogActions>
        </Dialog>

     <UploadDialog onClose={() => setOpenImportUser(false)} open={openImportUser} title="用户导入" onSave={handleImport} />
    </React.Fragment>
}

export default User